import React from 'react'
import './style.css'
import NumberFormat from 'react-number-format';

export default class ControlBar extends React.Component{

    state = {
        isOpen : false,
        lote : 0,
        vezes : 1
    }

    VALOR_ADICIONAL_ANUAL_NORMAL = 1500
    VALOR_ADICIONAL_ANUAL_MURO = 2000
    VALOR_ADICIONAL_ANUAL_AV = 3000

    VALOR_METRO_NORMAL = 234
    VALOR_METRO_MURO = 269
    VALOR_METRO_AV = 400

    TIPO_AV = "Q"
    TIPO_MURO = "R"
    TIPO_NORMAL = "S"

    valorMetro = (lote) =>{
		switch(lote.tipo){
			case this.TIPO_AV:
				return this.VALOR_METRO_AV
			case this.TIPO_MURO:
				return this.VALOR_METRO_MURO
			case this.TIPO_NORMAL:
				return this.VALOR_METRO_NORMAL
		}
	}

	valorAnual = (lote) =>{
		switch(lote.tipo){
			case this.TIPO_AV:
				return this.VALOR_ADICIONAL_ANUAL_AV
			case this.TIPO_MURO:
				return this.VALOR_ADICIONAL_ANUAL_MURO
			case this.TIPO_NORMAL:
				return this.VALOR_ADICIONAL_ANUAL_NORMAL
		}
	}

    avista = (lote)=> lote.area*this.valorMetro(lote)
    
    calcularParcela = (avista, n_parcelas) => this.normalizeNumber(2.5+((avista)/n_parcelas))

	normalizeNumber = (n) => ((Math.round( n * 100)) / 100)

    setLote = (lote) => this.setState({lote})

    open = () => this.setState({isOpen:true})
    close = () => this.setState({isOpen:false})
    toggle = () => this.setState({isOpen:!this.state.isOpen})

    isOpen = () => this.state.isOpen

    mudarDisponibilidade = (id, e) =>{
        console.log('mudarDisponibilidade = (value)',id-1, e.target.value)
        this.props.mudarDisponibilidade(id-1, e.target.value)
    }

    currency = (n) => <NumberFormat value={this.normalizeNumber(n)} displayType={'text'} thousandSeparator={'.'} decimalSeparator={','} prefix={'R$'} />

    vezesHandler = (e)=>this.setState({vezes:e.target.value})

    render() {

        let lotes = this.props.lotesInfos.toArray()
        let lote = lotes[this.state.lote]

        console.log('let lote = lotes[this.state.lote]', lote)
        
        if(lote)
            return(
                <div className={`control_bar_container ${this.state.isOpen?'open':'closed'}`}>
                    <div className='first'>
                        <div className='labels'>
                            <span>Lote</span>
                            <span>Área (m²)</span>
                            <span>Disponibilidade</span>
                            <span>Valor a vista</span>
                            <span>Tipo localização</span>
                            <span>Valor metro</span>
                            <span>Em <input type="number" name="quantity" placeholder={this.state.vezes} value={this.state.vezes} onChange={this.vezesHandler} min="1"/> vezes</span>
                            <span>Anual</span>
                            <span>Atualizado por</span>
                        </div>
                        <div className='values'>
                            <span>{lote.id}</span>
                            <span>{lote.area}</span>
                            <span>{lote.disponibilidade}</span>                            
                            <span>
                                {this.currency(this.avista(lote))}
                            </span>
                            <span>
                                {lote.tipo==this.TIPO_AV?'Avenida ou esquina':
                                 lote.tipo==this.TIPO_MURO?'Murado ao fundo':
                                 'Lote normal'}
                            </span>
                            <span>{this.currency(this.valorMetro(lote))}</span>
                            <span>{this.currency(this.calcularParcela(this.avista(lote),this.state.vezes))}</span>
                            <span>{this.currency(this.valorAnual(lote))}</span>
                            <span>{lote.pessoa}</span>
                        </div>

                        <div className='disponibilidade_setter'>
                            <label className={`${lote.disponibilidade=="Disponível"?'selected':''} disponivel`}>
                                <input type='radio' value="Disponível" onChange={(e) => this.mudarDisponibilidade(lote.id, e)} checked={lote.disponibilidade=="Disponível"}/>
                                Disponível
                            </label>
                            <label className={`${lote.disponibilidade=="Vendido"?'selected':''} vendido`}>
                                <input type='radio' value="Vendido" onChange={(e) => this.mudarDisponibilidade(lote.id, e)}  checked={lote.disponibilidade=="Vendido"}/>
                                Vendido
                            </label>
                            <label className={`${lote.disponibilidade=="Em negociação"?'selected':''} negociacao`}>
                                <input type='radio' value="Em negociação" onChange={(e) => this.mudarDisponibilidade(lote.id, e)} checked={lote.disponibilidade=="Em negociação"}/>
                                Em negociação
                            </label>
                        </div>
                    </div>                    
                </div>
            )
        else
            return <div/>
    }
}


// WEBPACK FOOTER //
// ./src/views/administrativo/vendas/controlbar/component.js